import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    backdropContainer: {
      position: "fixed",
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  { name: "N0Backdrop" },
);

export { useStyles };
